import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const APIKeyModel = types.model("APIKeyModel", {
  apiKeyId: types.identifier,
  status: types.enumeration("APIKeyStatus", ["ACTIVE", "EXPIRED"]),
  expiresAt: types.string,
  isAdmin: types.boolean,
  createdAt: types.string,
  projectIds: types.array(types.string),
});

export const createAPIKeyModel = (
  snapshot: SnapshotIn<typeof APIKeyModel>,
): Instance<typeof APIKeyModel> => APIKeyModel.create(snapshot);
